module.exports = __webpack_public_path__ + "static/egyptian-pillowcase-dusty-rose-2-d6b23fdcb5dfb79612d18cae864a1db0.webp";